import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-request-email-change.component.less'],
  templateUrl: './tellent-request-email-change.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentRequestEmailChangeTemplateComponent {
  public readonly data = input.required<WrappedValue<TellentRequestEmailChangeTemplateData>>();
}

export type TellentRequestEmailChangeTemplateData = {
  avatar_url: string;
  header: string;
  subheader_html: string;
  p1_html: string;
  p2: string;
  p3: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
};

export const TellentRequestEmailChangeTemplateMocks: TellentRequestEmailChangeTemplateData[] = [
  {
    avatar_url:
      'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
    header: 'Request to change your email address',
    subheader_html: `Hello %{user_name}! 👋 We’ve received a request from <b>%{requester_name}</b> to change the email address for your Tellent account to <a href="%{new_email}">%{new_email}</a>. Please confirm this change by clicking the button below.`,
    p1_html: `Current email: <a href='%{current_email}'>%{current_email}</a><br />New email: <a href='%{new_email}'>%{new_email}</a>`,
    p2: 'If you don’t want to change your email address, simply ignore this email.',
    p3: 'If this change hasn’t been made by you or someone from your team, please contact our support.',
    footer: {
      text: 'Need help?',
      href: 'https://auth.tellent.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
    primary_cta: {
      href: 'https://tellent.com',
      label: 'Confirm change',
    },
  },
];
